import * as React from 'react';
import { Form, Modal, Select } from 'antd';
import './UsersComponent.scss';
import * as i18next from 'i18next';
import { FormInstance } from 'antd/lib/form';
import { CloseOutlined } from '@ant-design/icons/lib/icons';

interface IProps {
    role: string;
    visible: boolean;
    onCancel: Function;
    onSubmit: Function;
    t: i18next.TFunction;
}

export class ChangeUserRolePopupComponent extends React.Component<IProps> {
    form: React.RefObject<FormInstance> = React.createRef<FormInstance>();

    onCancel = () => {
        this.props.onCancel();
    };

    onSubmit = () => {
        const { current } = this.form;

        if (current) {
            current
                .validateFields()
                .then((values: any) => {
                    current.resetFields();
                    this.props.onSubmit(values);
                })
                .catch();
        }
    };

    render = () => {
        const { role, visible, t } = this.props;
        const { Option } = Select;

        return (
            <Modal
                className="changeUserRole"
                open={visible}
                title={t('edit_user_role')}
                okText={t('save')}
                onCancel={this.onCancel}
                onOk={this.onSubmit}
                closable={{closeIcon: <><CloseOutlined className="ml-2" /></>}}
            >
                <Form layout="vertical" ref={this.form}>
                    <Form.Item
                        label={t('role')}
                        className="role"
                        name="role"
                        initialValue={role.toLowerCase()}
                        rules={[{ required: true }]}
                    >
                        <Select size="large" placeholder={t('select_role')}>
                            <Option value="admin">{t('admin')}</Option>
                            <Option value="manager">{t('manager')}</Option>
                            <Option value="user">{t('user')}</Option>
                            <Option value="account_manager">{t('account_manager')}</Option>
                            <Option value="regulator">Regulator</Option>
                        </Select>
                    </Form.Item>
                </Form>
            </Modal>
        );
    };
}
